var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsersColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symmio Plus Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 348",
    width: 80,
    height: 80,
    rx: 20,
    fill: "#ADDFFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.2854 38C53.4397 38 55.9769 35.44 55.9769 32.2857C55.9769 29.1314 53.4397 26.5714 50.2854 26.5714C47.1312 26.5714 44.5712 29.1314 44.5712 32.2857C44.5712 35.44 47.1312 38 50.2854 38ZM33.1426 35.7143C36.9369 35.7143 39.9769 32.6514 39.9769 28.8571C39.9769 25.0629 36.9369 22 33.1426 22C29.3483 22 26.2854 25.0629 26.2854 28.8571C26.2854 32.6514 29.3483 35.7143 33.1426 35.7143ZM50.2854 42.5714C46.1026 42.5714 37.714 44.6743 37.714 48.8571V54H62.8569V48.8571C62.8569 44.6743 54.4683 42.5714 50.2854 42.5714ZM33.1426 40.2857C27.8169 40.2857 17.1426 42.96 17.1426 48.2857V54H33.1426V48.8571C33.1426 46.9143 33.8969 43.5086 38.5597 40.9257C36.5711 40.5143 34.6511 40.2857 33.1426 40.2857Z",
    fill: "#121622"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersColored);
export default __webpack_public_path__ + "static/media/icon_users-colored.4c2486bb99d2968be6dbbf6878c51612.svg";
export { ForwardRef as ReactComponent };